import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon62: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 14.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 14" width={width} height={height} {...props}>
      <Path
        d="M8.34283 0.287126C9.09883 -0.0958741 9.97682 -0.0928697 10.6908 0.27913L18.6888 3.53813C18.7018 3.54313 18.7158 3.54914 18.7278 3.55614C18.7378 3.56114 18.7488 3.56714 18.7588 3.57314C18.7778 3.58414 18.7938 3.59514 18.8098 3.60814C18.8148 3.61314 18.8218 3.61812 18.8278 3.62312C18.8458 3.63712 18.8618 3.65314 18.8758 3.66914C18.8788 3.67514 18.8828 3.67913 18.8868 3.68413C18.9378 3.74413 18.9718 3.81613 18.9878 3.89113C18.9958 3.92613 18.9998 3.96315 18.9998 4.00115L18.9938 3.92415C18.9958 3.93915 18.9978 3.95313 18.9988 3.96813L18.9998 4.00115L19.0008 8.08513C19.5828 8.29113 19.9998 8.84613 19.9998 9.49913V12.4971C19.9998 12.7731 19.7758 12.9971 19.4998 12.9971H17.4998C17.2238 12.9971 16.9998 12.7731 16.9998 12.4971V9.49913C16.9998 8.84613 17.4168 8.29113 17.9998 8.08513V4.81114L15.9928 5.82314V13.5001C15.9928 13.7461 15.8168 13.9501 15.5828 13.9921L15.4928 14.0001H3.49983C3.22383 14.0001 2.99983 13.7761 2.99983 13.5001V5.81114L0.275828 4.44814C-0.0791716 4.27014 -0.0871676 3.78213 0.226832 3.58113L0.311824 3.53713L8.34283 0.287126ZM3.99983 6.31114V13.0001H14.9928V6.32613L10.7318 8.47514C10.0278 8.83914 9.21782 8.86714 8.50383 8.56114L8.32682 8.47814L3.99983 6.31114ZM18.4998 8.99913C18.2238 8.99913 17.9998 9.22213 17.9998 9.49913V11.9971H18.9998V9.49913C18.9998 9.22213 18.7768 8.99913 18.4998 8.99913ZM10.2718 1.18614C9.79783 0.941143 9.25383 0.941143 8.78083 1.18614L8.73883 1.20513L1.71282 4.04915L8.78083 7.58714C9.25383 7.83214 9.79782 7.83213 10.2768 7.58513L15.1888 5.10713C15.2378 5.06913 15.2938 5.04115 15.3548 5.02315L17.2938 4.04915L10.2718 1.18614Z"
        fill="#404040"
      />
    </Icon>
  )
}
